import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from '../../components/funcs/BASES/withRouter'

import { TableOne } from '../../components/lib/table'
import { Cols } from '../../components/features/TableCols/BeslenmeType'
import { FaPlus } from 'react-icons/fa'
import { IconButton } from '../../components/lib/button'
import { GridBlock } from '../../components/lib/grid'
import { ParallaxCard } from '../../components/lib/cards'

import endPoints from '../../components/Consts/endPoints.json'
import * as BeslenmeTypeActions from '../../redux/actions/BeslenmeType'


class BeslenmeType extends Component {
  constructor (props) {
    super(props)
    this.state = {
      loginOnProcess: false,
    }
    this.releatedRoutes = endPoints.find(aa => aa.name == 'BeslenmeType')?.routes
  }

  componentDidMount () {
    this.props.actions.GetAll(
      null,
      () => { this.setState({ loginOnProcess: false }) },
      () => { setTimeout(() => { this.setState({ loginOnProcess: false }) }, 1000) },
      () => {},
      () => {}
    )
  }

  update = id => {
    this.props.router.navigate(this.releatedRoutes.create, {
      replace: true,
      state: { id }
    })
  }

  toggleActive = id => {
    this.props.actions.ToggleActive(
      id,
      () => {},
      () => {},
      () => {},
      () => {}
    )
  }

  render () {
    return (
      <GridBlock style={{ padding: 10 }}>
        <TableOne
          title={'Beslenme Yayın Yerleri'}
          responsive={true}
          subHeader={true}
          columns={Cols(this.update, this.toggleActive)}
          data={this.props.BeslenmeTypeReducers?.All}
          pagination={true}
          subHeaderComponent={
            <GridBlock container justify={'space-between'} align={'space-between'} style={{ padding: 10 }}>
              <IconButton
                icon={<FaPlus />}
                onClick={() => {
                  this.props.router.navigate(this.releatedRoutes.create)
                }}
              />
            </GridBlock>
          }
        />

        <ParallaxCard
          imageOne={require('../../asserts/images/cards/yoga/extended2.png')}
          imageTwo={require('../../asserts/images/cards/flower4.png')}
          imageThree={require('../../asserts/images/cards/flowers3.png')}
          imageFour={require('../../asserts/images/cards/flower.png')}
        />
      </GridBlock>
    )
  }
}

function mapStateToProps (state) {
  return {
    BeslenmeTypeReducers: state.BeslenmeTypeReducers
  }
}

function mapDispatchToProps (dispatch) {
  return {
    actions: {
      GetAll: bindActionCreators(BeslenmeTypeActions.GetAll, dispatch),
      ToggleActive: bindActionCreators(BeslenmeTypeActions.ToggleActive, dispatch),
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BeslenmeType))
